import {BBModel} from '../bb_model';
import {context} from '../constants/context';
import {halClient} from '../hal';

const person = {
    query(company) {
        return new Promise((resolve, reject) => {
            if (!company.$has('people')) {
                reject('No people found');
            } else {
                company.$get('people').then((resource) => {
                        return resource.$get('people').then((items) => {
                                const people = [];
                                for (const i of Array.from(items)) {
                                    people.push(new BBModel.Person(i));
                                }
                                return resolve(people);
                            }
                        );
                    }
                    , (err) => {
                        return reject(err);
                    }
                );
            }
        });
    },

    async queryById(companyId, personId) {
        const url = `${context.apiUrl}/api/${context.apiVersion}/${companyId}/people/${personId}`;
        return new BBModel.Person(await halClient.$get(url));
    },

    async queryByReference(companyId, reference) {
        try {
            const url = `${context.apiUrl}/api/${context.apiVersion}/${companyId}/people/find_by_ref/${reference}`;
            return new BBModel.Person(await halClient.$get(url));
        } catch (ignored) {
            return Promise.reject('Invalid person reference: ' + reference);
        }
    }
};

export {
    person
};
